<template>
  <div class="changePayPwdWrapper">
    <p class="changepwdTitle">使用状态</p>
    <el-radio-group v-model="pwdstatus">
      <el-radio :label="0">我记得支付密码</el-radio>
      <el-radio :label="1">我不记得支付密码</el-radio>
    </el-radio-group>
    <div class="knowPwd" v-if="pwdstatus == 0">
      <div class="oldWrapper">
        <span class="title"> <i>*</i> 旧密码：</span>
        <div class="pwd_box">
          <input ref="oldpwd" type="text" maxlength="6" v-model="oldPassword" class="pwd" unselectable="on" />
          <ul class="pwd-wrap" @click="oldfocus">
            <li v-for="(item, index) in arr" :key="index" :class="oldPassword.length == item ? 'psd-blink' : ''">
              <i v-if="oldPassword.length > item && oldPwdType == 'pwd'"></i>
              <span v-if="oldPwdType == 'text'">{{ oldPassword[item] }}</span>
            </li>
          </ul>
        </div>
        <span class="msvg" :class="oldPwdType == 'pwd' ? 'hidden' : ''" @click="changeOldType"></span>
      </div>
      <div class="newWrapper">
        <span class="title"> <i>*</i> 新密码：</span>
        <div class="pwd_box">
          <input ref="newpwd" type="text" maxlength="6" v-model="password" class="pwd" unselectable="on" />
          <ul class="pwd-wrap" @click="newfocus">
            <li v-for="(item, index) in arr" :key="index" :class="password.length == item ? 'psd-blink' : ''">
              <i v-if="password.length > item && newPwdType == 'pwd'"></i>
              <span v-if="newPwdType == 'text'">{{ password[item] }}</span>
            </li>
          </ul>
        </div>
        <span class="msvg" :class="newPwdType == 'pwd' ? 'hidden' : ''" @click="changenewType"></span>
      </div>
      <el-button type="primary" style="margin-top: 156px; margin-left: 110px" @click="knowSave">保存</el-button>
    </div>
    <div class="unknowPwd" v-if="pwdstatus == 1">
      <div class="phonevaildWrapper">
        <span class="title"> <i>*</i> 手机验证：</span>
        <div class="phonevaild">
          <p>
            请您使用 <i>{{ phoneNo }}</i> 手机接收短信
          </p>
          <div>
            <el-input v-model="unknowPwdForm.smsCode" style="width: 170px" placeholder="请输入验证码"></el-input>
            <el-button type="primary" style="margin-left: 10px; width: 136px" v-if="msgtime == 60" @click="getsmscode"
              >获取验证码</el-button
            >
            <el-button disabled type="primary" style="margin-left: 10px" v-if="msgtime < 60"
              >{{ msgtime }}s后重新获取</el-button
            >
          </div>
        </div>
      </div>
      <!-- 实人认证相关逻辑已注释
      <div class="humanvalidWrapper">
        <span class="title"> <i>*</i>实人认证：</span>
        <div class="humanvalid" v-if="humanValid">
          <span>已认证</span>
        </div>
        <div class="humanvalid" @click="handleFacevalid" v-else>
          <span>去认证 </span>
        </div>
      </div>
      -->
      <div class="newPwdWrapper">
        <span class="title"> <i>*</i> 新密码：</span>
        <div class="pwd_box">
          <input
            ref="unknowPwdnewpwd"
            type="text"
            maxlength="6"
            v-model="unknowPwdForm.password"
            class="pwd"
            unselectable="on"
          />
          <ul class="pwd-wrap" @click="unknowPwdnewfocus">
            <li
              v-for="(item, index) in arr"
              :key="index"
              :class="unknowPwdForm.password.length == item ? 'psd-blink' : ''"
            >
              <i v-if="unknowPwdForm.password.length > item && unknowPwdnewPwdType == 'pwd'"></i>
              <span v-if="unknowPwdnewPwdType == 'text'">{{ unknowPwdForm.password[item] }}</span>
            </li>
          </ul>
        </div>
        <span class="msvg" :class="unknowPwdnewPwdType == 'pwd' ? 'hidden' : ''" @click="changeunknowPwdType"></span>
      </div>
      <el-button type="primary" style="margin-top: 156px; margin-left: 110px" @click="unknowSave">保存</el-button>
    </div>
    <!-- 实人认证弹窗已注释
    <DtPopup :isShow.sync="showQRcode" title="实人认证" @close="showQRcode = false" :footer="false">
      <div class="codeWrap" @click.stop>
        <img :src="QRcodeUrl" alt="" @click.stop />
        <p>打开微信扫描二维码穿越到手机<br />进行实人认证</p>
      </div>
    </DtPopup>
    -->
  </div>
</template>
<script>
import { userSafetyInfoupdatepayment, userSafetyInfosendsmsCode, /* userSafetyInfoverifyface */ } from '@/api/userCenter'; // 实人认证API已注释
import { encrypt, decrypt } from '@/utils/rsaEncrypt'; //加密，解密
import qs from 'qs';
import DtPopup from '@/components/layouts/DtPopup';
export default {
  props: {
    phoneNo: {
      type: String,
      default: '',
    },
  },
  components: {
    DtPopup,
  },
  // 实人认证相关watch已注释
  // watch: {
  //   '$store.state.user.bizTokenInfo'(newValue) {
  //     if (newValue && newValue.bizToken && newValue.type == 3) {
  //       this.humanValid = true;
  //       this.showQRcode = false;
  //     }
  //   },
  // },
  data() {
    return {
      pwdstatus: null,
      oldPassword: '',
      oldPwdType: 'pwd',
      password: '',
      newPwdType: 'text',
      unknowPwdForm: {
        smsCode: '',
        password: '',
      },
      arr: [0, 1, 2, 3, 4, 5],
      unknowPwdnewPwdType: 'text',
      msgtime: 60,
      // showQRcode: false, // 实人认证相关数据已注释
      // QRcodeUrl: '', // 实人认证相关数据已注释
      // humanValid: false, // 实人认证相关数据已注释
    };
  },
  methods: {
    oldfocus() {
      this.$refs.oldpwd.focus();
    },
    changeOldType() {
      this.oldPwdType = this.oldPwdType == 'pwd' ? 'text' : 'pwd';
    },
    newfocus() {
      this.$refs.newpwd.focus();
    },
    changenewType() {
      this.newPwdType = this.newPwdType == 'pwd' ? 'text' : 'pwd';
    },
    unknowPwdnewfocus() {
      this.$refs.unknowPwdnewpwd.focus();
    },
    changeunknowPwdType() {
      this.unknowPwdnewPwdType = this.unknowPwdnewPwdType == 'pwd' ? 'text' : 'pwd';
    },
    getsmscode() {
      let that = this;
      userSafetyInfosendsmsCode(
        qs.stringify({
          userId: this.$store.state.user.user.userId,
        })
      ).then((res) => {
        if (res) {
          let time = 60;
          let t1 = setInterval(function () {
            time--;
            that.msgtime = time;
            if (time <= 0) {
              clearInterval(t1);
              that.msgtime = 60;
            }
          }, 1000);
        }
      });
    },
    knowSave() {
      let oldPassword = this.oldPassword;
      let password = this.password;
      if (oldPassword.length < 6) {
        this.$message.error('请输入六位旧密码');
        return;
      }
      if (password.length < 6) {
        this.$message.error('请输入六位新密码');
        return;
      }
      let params = {
        userId: this.$store.state.user.user.userId,
        updateType: 1,
        oldPassword: encrypt(oldPassword),
        password: encrypt(password),
      };
      userSafetyInfoupdatepayment(params).then((res) => {
        if (res.resultType == 1) {
          this.$message.success(res.resp_msg);
        } else if (res.resultType == 2) {
          this.$message.error(res.resp_msg);
        }

        this.oldPassword = '';
        this.password = '';
      });
    },
    unknowSave() {
      // 校验手机验证码以及支付密码
      let smsCode = this.unknowPwdForm.smsCode;
      let password = this.unknowPwdForm.password;
      if (!smsCode) {
        this.$message.error('手机验证码不能为空');
        return;
      }
      // 实人认证验证已注释
      // if (!this.humanValid) {
      //   this.$message.error('请先完成实人认证');
      //   return;
      // }
      if (password.length < 6) {
        this.$message.error('请输入六位新密码');
        return;
      }
      let params = {
        userId: this.$store.state.user.user.userId,
        smsCode: this.unknowPwdForm.smsCode,
        updateType: 2,
        password: encrypt(this.unknowPwdForm.password),
        // bizToken: this.$store.state.user.bizTokenInfo.bizToken, // 实人认证token已注释
      };
      userSafetyInfoupdatepayment(params).then((res) => {
        if (res.resultType == 1) {
          this.$message.success(res.resp_msg);
        } else if (res.resultType == 2) {
          this.$message.error(res.resp_msg);
        }
        this.unknowPwdForm.smsCode = '';
        this.unknowPwdForm.password = '';
      });
    },
    // 实人认证相关方法已注释
    // handleFacevalid() {
    //   // 去认证前，需要清空存在store的setbizToken
    //   this.$store.commit('user/setbizTokenInfo', {});
    //   userSafetyInfoverifyface({
    //     userId: this.$store.state.user.user.userId,
    //     type: 3,
    //   }).then((res) => {
    //     if (res) {
    //       this.QRcodeUrl = res.url;
    //       this.showQRcode = true;
    //     }
    //   });
    // },
  },
};
</script>
<style lang="less" scoped>
.changePayPwdWrapper {
  margin-top: 38px;
  .changepwdTitle {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #55555a;
    line-height: 20px;
    margin-bottom: 20px;
  }
  .knowPwd {
    padding-top: 60px;
    .oldWrapper,
    .newWrapper {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .title {
        flex: 0 0 80px;
        i {
          color: rgba(255, 106, 0, 1);
        }
      }
      .msvg {
        cursor: pointer;
        margin-left: 20px;
        width: 18px;
        height: 12px;
        background: url(~@/assets/imgs/view.png) no-repeat;
        background-size: 100% 100%;
        &.hidden {
          height: 8px;
          background: url(~@/assets/imgs/hidden.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .unknowPwd {
    padding-top: 60px;
    .phonevaildWrapper,
    .humanvalidWrapper,
    .newPwdWrapper {
      display: flex;
      margin-bottom: 20px;
      .title {
        flex: 0 0 100px;
        i {
          color: rgba(255, 106, 0, 1);
        }
      }
      .phonevaild {
        p {
          margin-bottom: 16px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #55555a;
          i {
            color: rgba(87, 136, 187, 1);
          }
        }
      }
      .humanvalid {
        width: 84px;
        height: 26px;
        background: #fff6e7;
        border-radius: 15px;
        border: 1px solid #e27c00;
        text-align: center;
        line-height: 26px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #e27c00;
        cursor: pointer;
      }
      .msvg {
        cursor: pointer;
        margin-left: 20px;
        width: 18px;
        height: 12px;
        background: url(~@/assets/imgs/view.png) no-repeat;
        background-size: 100% 100%;
        &.hidden {
          height: 8px;
          background: url(~@/assets/imgs/hidden.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .humanvalidWrapper,
    .newPwdWrapper {
      align-items: center;
    }
  }
}
// 输入支付密码样式
.pwd_box {
  height: auto;
  display: inline-flex;
  input {
    width: 0.1px;
    height: 0.1px;
    color: transparent;
    // position: relative;
    // top: 23px;
    background: #000000;
    // left: 46px;
    border: none;
    font-size: 18px;
    opacity: 0;
    z-index: -1;
  }
  //光标
  .psd-blink {
    display: inline-block;
    // background: url(~@/assets/imgs/blink.png) no-repeat center center;
  }
  .pwd-wrap {
    height: 36px;
    padding-bottom: 1px;
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    cursor: pointer;
    // position: absolute;
    // left: 0;
    // right: 0;
    // top: 13%;
    z-index: 10;
    li {
      width: 36px;
      height: 36px;
      margin-right: 8px;
      list-style-type: none;
      text-align: center;
      line-height: 36px;
      border: 1px solid #ddd;
      i {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background: #000;
        display: inline-block;
      }
    }
  }
  button {
    position: relative;
    display: block;
    height: 41px;
    text-align: center;
    margin: 0 auto;
    margin-top: 70%;
    padding: 0 20px;
    border-radius: 5px;
    font-size: 16px;
    border: 1px solid #dddddd;
    background: #dddddd;
    color: #000000;
  }
}
.blink {
  animation: blink 3s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale(2);
  }
  51% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.codeWrap {
  text-align: center;
  padding-bottom: 50px;
  img {
    width: 200px;
    height: 200px;
    border: 5px solid #000;
    border-radius: 10px;
    margin: 10px 0;
  }
  p {
    color: #555;
    font-size: 16px;
    line-height: 1.5;
  }
  .claimCardList .claimTitle .iconLian[data-v-d870e762] {
    display: inline-block;
    vertical-align: top;
    margin-left: 1.067vw;
    width: 4.267vw;
    height: 4.267vw;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAGZklEQ…ZyV2ay/dJU1l+boxEoqy9OEgBZf3U2CkKWXp6OnYiz7fr8v+VIg/gO9qg/AAAAAElFTkSuQmCC)
      no-repeat;
    background-size: contain;
  }
}
</style>